import { authenticatedFetch } from '../../../api/request';

export default async function getAllEducations(doctorId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las entradas de educación.');
    return await authenticatedFetch(`/doctor-profile-management/all-educations/${doctorId}`, onError);
}
